import { render, staticRenderFns } from "./NodeNetwork.vue?vue&type=template&id=10effdcf&scoped=true&"
import script from "./NodeNetwork.vue?vue&type=script&lang=js&"
export * from "./NodeNetwork.vue?vue&type=script&lang=js&"
import style0 from "./NodeNetwork.vue?vue&type=style&index=0&id=10effdcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10effdcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10effdcf')) {
      api.createRecord('10effdcf', component.options)
    } else {
      api.reload('10effdcf', component.options)
    }
    module.hot.accept("./NodeNetwork.vue?vue&type=template&id=10effdcf&scoped=true&", function () {
      api.rerender('10effdcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Node/NodeNetwork.vue"
export default component.exports